import React from 'react';
import {Flex, Text, Icon, Link, Menu, Tooltip} from '@chakra-ui/react';
import {Link as ReachLink} from 'react-router-dom';

export default function NavItem({icon, title, active, navSize, screen, visible = true}) {
  return (
    <Flex mt={30} flexDir="column" w="100%" alignItems={navSize == 'small' ? 'center' : 'flex-start'} style={visible ? {} : {display: 'none'}}>
      <Menu placement="right">
        <Tooltip label={navSize == 'small' ? title : ''}>
          <Link
            backgroundColor={active && 'secondary.200'}
            p={3}
            borderRadius={8}
            _hover={{textDecor: 'none', backgroundColor: 'secondary.100', textColor: 'Black'}}
            w={navSize == 'large' && '100%'}
            as={ReachLink}
            to={screen}
          >
            <Flex>
              <Icon as={icon} fontSize="xl" color={active ? 'primary.800' : 'graystone.primary'} />
              <Text ml={5} display={navSize == 'small' ? 'none' : 'flex'} color={active && 'primary.800'}>
                {title}
              </Text>
            </Flex>
          </Link>
        </Tooltip>
      </Menu>
    </Flex>
  );
}
